import { stringify } from "query-string";
import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";

import {
  DocumentInput,
  TicketTemplate,
} from "../../shared/interfaces";
import { PATH } from "../../shared/constants";

export const getTemplatesRequest = async (
  team?: string,
  teamId?: string,
  listAll?: boolean,
): Promise<TicketTemplate[]> => {
  const params = stringify({
    team: team || "",
    teamId: teamId || "",
    all: listAll ? "true" : undefined,
  }, { skipNull: true });

  try {
    const response = await instance.get(`${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}?${params}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getTemplateByIdRequest = async (templateId: string): Promise<TicketTemplate> => {
  try {
    const response = await instance.get(`${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}/${templateId}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const addTemplateRequest = async (request: FormData): Promise<DocumentInput> => {
  try {
    const response = await instance.post<DocumentInput>(`${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}`, request);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const updateTemplateRequest = async (
  request: TicketTemplate, templateId: string,
): Promise<DocumentInput> => {
  try {
    const response = await instance.put<DocumentInput>(`${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}/${templateId}`, request);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const backfillTemplateTeamIdsRequest = async (): Promise<{
  updated: number;
  skipped: number;
}> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}/backfill-team-ids`,
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const deleteTemplateRequest = async (templateId: string): Promise<boolean> => {
  try {
    await instance.delete<DocumentInput>(`${PATH.API}/${PATH.OPERATOR}/${PATH.TEMPLATE}/${templateId}`);

    return true;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
